var $9a7348e0caa19677$exports = {};
$9a7348e0caa19677$exports = {
    "longPressMessage": `Lai atv\u{113}rtu izv\u{113}lni, turiet nospiestu vai nospiediet tausti\u{146}u kombin\u{101}ciju Alt + lejupv\u{113}rst\u{101} bulti\u{146}a`
};


export {$9a7348e0caa19677$exports as default};
//# sourceMappingURL=lv-LV.mjs.map
